/**
 * Determines whether the PA status from the API differs from what is already
 * recorded in the referral notes (case-insensitive comparison).
 */
export function shouldWriteBackPaStatus(
  apiStatus: string | undefined | null,
  notesStatus: string | undefined | null,
): boolean {
  if (!apiStatus) return false;
  if (!notesStatus) return true;
  return apiStatus.toLowerCase() !== notesStatus.toLowerCase();
}
